<template>
  <div class="person-info">
    <div class="template-title">参赛人员上传资料</div>
    <player-info class="player-wrapper" />
    <section v-loading="loading">
      <div
        v-for="(template, index) in datas"
        :key="index"
      >
        <p class="template-title">{{template.title}}</p>
        <file-uploader
          :canDownload="download"
          :fileDesc="template.desc"
          :type="template.type"
          v-model="template.materials"
          :status="status"
          :activityId="activity_id"
          :playerId="player_id"
          :hidenFileStatus='true'
          @downloadAttachment="downloadAttachment"
        ></file-uploader>
      </div>
    </section>
  </div>
</template>
<script>
import PlayerInfo from '@/components/player-info/index'
import FileUploader from '@/components/MaterialUploader'
import { getMaterialRequired, getMaterialDetailV3, getCourseWareDetails } from '../service/contestantInfo.js'
import { processingDefaultMaterial, processingDetailWithDefaultData } from '../model/processingData'
import download from '../assets/downloader'
import auditStatus from '@/model/auditStatus'

export default {
  components: {
    FileUploader,
    PlayerInfo
  },
  data () {
    return {
      uploadHeaders: {
        'Authentication-Token': localStorage.getItem('auth_token')
      },
      headerTitle: '',
      tips: '',
      PersonInfo: {
        union: { title: '' },
        name: '',
        number: '',
        telephone: '',
        gender: 'male'
      },
      loading: false,
      status: '',
      datas: [],
      activity: '',
      download: false,
      position: '',
      player_id: 0,
      activity_id: 0,
      sponsor: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    localStorage.getItem('auth_token') ? next() : next(`/?activity_id=${localStorage.getItem('activity_id')}`)
  },
  created () {
    this.PersonInfo = JSON.parse(localStorage.getItem('PersonInfo')).user
    this.activity_id = localStorage.getItem('activity_id')
    this.player_id = this.PersonInfo.id
    this.getfileList()
    if (this.PersonInfo.union === '' || !this.PersonInfo.union || this.PersonInfo.union === null) {
      let union = { title: '暂无' }
      let PersonInfo = this.PersonInfo
      PersonInfo.union = union
    }
    this.position = this.PersonInfo.union.province.name
    // 获取活动信息
    this.fetchActivity()
  },
  computed: {
    banner: function () {
      let activityInfo = JSON.parse(localStorage.getItem('PersonInfo')).activity
      const host = activityInfo.host
      var theme = activityInfo.union.theme ? activityInfo.union.theme.url : activityInfo.theme_url
      let data = activityInfo.modules.filter(value => {
        return value.category === 'apply' && value.module === 'theme'
      })
      if (data.length > 0) {
        const type = data[0].properties.category
        if (type === 'user-defined') {
          theme = data[0].properties.url
        }
      }
      return host + theme
    }
  },
  methods: {
    downloadAttachment (type, path, file) {
      if (this.download) {
        let url = path
        if (file && file.name) {
          url = this.encodeFileNameInUrl(path, file.name)
        }
        download(1, url, '')
      }
    },
    encodeFileNameInUrl (url, filename) {
      if (!filename || url.indexOf(filename) === -1) {
        return url
      }
      let encodeFileName = encodeURIComponent(filename)
      return url.replace(filename, encodeFileName)
    },
    _getCourseWareDetails () {
      getCourseWareDetails(this.activity_id, this.player_id).then(res => {
        if (res.data && res.data.is_selected && res.data.id) {
          this.$router.push(`/${this.activity_id}/${this.player_id}/CourseWareDetail`)
        }
      })
    },
    compSafariTime (str) {
      console.log(str)
      if (!str) {
        return ''
      }
      return str.replace(/-/g, '/')
    },
    fetchActivity () {
      let activityInfo = JSON.parse(localStorage.getItem('PersonInfo')).activity
      this.activity = activityInfo.title
      if (activityInfo.sponsors && activityInfo.sponsors.length > 0) {
        this.sponsor = '主办单位：' + activityInfo.sponsors.map(item => item.title).join('、')
      } else {
        this.sponsor = '主办单位：' + activityInfo.union.title
      }
      let finalDate, dayBefore
      let nowDate = new Date().getTime()
      for (let i in activityInfo.modules) {
        if (activityInfo.modules[i].category === 'scene' && activityInfo.modules[i].module === 'scene_contest' && activityInfo.modules[i].properties) {
          finalDate = new Date(this.compSafariTime(activityInfo.modules[i].properties.final_start_time)).getTime()
          dayBefore = new Date(this.compSafariTime(activityInfo.modules[i].properties.final_start_time).split(' ')[0] + ' 00:00:00').getTime() - 24 * 60 * 60 * 1000
        }
      }
      if (nowDate >= dayBefore && nowDate <= finalDate) {
        this.headerTitle = '下载比赛演讲节段'
        this.tips = ''
      } else {
        this.headerTitle = '比赛演讲节段列表'
        this.tips = '(仅现场比赛前一天可以在此页面下载比赛演讲节段)'
      }
      this._getCourseWareDetails()
    },
    getSceneDate () {
      const activityInfo = JSON.parse(localStorage.getItem('PersonInfo')).activity
      if (!activityInfo || !activityInfo.modules || activityInfo.modules.length === 0) {
        return {
          start: '',
          end: ''
        }
      }
      let start = ''
      let end = ''
      activityInfo.modules.forEach(item => {
        if (item.module === 'scene_contest' && item.properties) {
          start = item.properties.final_start_time
          end = item.properties.final_start_time.replace(/00:00:00/, '23:59:59')
        }
      })
      return { start, end }
    },
    couldShowUploadBotton () {
      let scheneObj = this.getSceneDate()
      if (!scheneObj.start || !scheneObj.end) {
        return false
      }
      let sceneStartTimes = new Date(scheneObj.start.replace(/-/g, '/')).getTime()
      sceneStartTimes -= (24 * 60 * 60 * 1000)
      let sceneEndTimes = new Date(scheneObj.end.replace(/-/g, '/')).getTime()
      sceneEndTimes -= (24 * 60 * 60 * 1000)
      let currentTimes = new Date().getTime()
      return currentTimes >= sceneStartTimes && currentTimes <= sceneEndTimes
    },
    // 获取上传资料详情
    getMaterialDetail (id) {
      let activityId = localStorage.getItem('activity_id')
      getMaterialDetailV3(activityId).then((resDetail) => {
        this.loading = false
        this.status = resDetail.data.audit_status
        this.$store.dispatch(`commitMaterialsStatus`, this.status)
        if (this.status === auditStatus.APPROVED) {
          // 比赛前一天展示下载
          this.download = this.couldShowUploadBotton()
        }
        this.content = resDetail.data.content
        if (resDetail.data.detail.length > 0) {
          this.datas = processingDetailWithDefaultData(this.datas, resDetail.data.detail)
        }
        let desIndex = -1
        for (let i in this.datas) {
          if (this.datas[i].type === 'description') {
            desIndex = i
          }
        }
        if (desIndex !== -1) {
          this.datas.splice(desIndex, 1)
        }
      })
    },
    updateMapfilePath (filesArray, index, path, oper, type, name) {
      // 遍历更新路径和源文件名
      this.datas.forEach((item) => {
        if (type === 'img') {
          type = 'pic'
        }
        if ((type === 'pdf' && item.file_type === 'ppt')) {
          item.filesArray.forEach((fileItem, imgIndex) => {
            if (index === imgIndex) {
              if (oper === 'add') {
                // 如果是添加把文件路径，源文件名赋给一个新的变量
                fileItem.pathPdf = path
                fileItem.origin_title_pdf = name
              } else {
                // 否则复为空
                fileItem.pathPdf = ''
                fileItem.origin_title_pdf = ''
              }
            }
          })
        }
        // 当文件类型等于要求文件类型时
        if (item.file_type === type) {
          if (item.filesArray) {
            item.filesArray.forEach((fileItem, imgIndex) => {
              if (index === imgIndex) {
                if (oper === 'add') {
                  fileItem.path = path
                  fileItem.origin_title = name
                } else {
                  fileItem.path = ''
                  fileItem.origin_title = ''
                }
              }
            })
          }
        }
      })
      this.$forceUpdate()
    },
    getfileList () {
      // 获取材料要求
      getMaterialRequired(localStorage.getItem('activity_id')).then((res) => {
        this.loading = false
        let resData = res.data
        this.datas = processingDefaultMaterial(resData)
        // 获取材料上传详情信息
        this.getMaterialDetail()
      })
    },
    back () {
      this.$router.go(-1)
      // 返回
    },
    mapChanel (filesArray, icon) {
      filesArray.map((item) => {
        if (item.iconPpt) {
          item.iconPpt = icon
        } else if (item.iconPdf) {
          item.iconPdf = icon
        } else {
          item.icon = icon
        }
      })
    },
    chanel () {
      event.$emit('clearUploadList')
      this.datas.map((item) => {
        if (item.filesArray) {
          if (!(item.file_type === 'description' || item.file_type === 'text')) {
            this.mapChanel(item.filesArray, require(`../assets/images/${item.file_type}.png`))
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.person-info {
  width: 100%;
  max-width: 686px;
  margin: 0 auto;
  padding-top: 25px;
}
.template-title {
  font-size: 20px;
  font-weight: 600;
  color: #4E5A73;
  padding-left: 10px;
  position: relative;
  &::before {
    content: '';
    width: 6px;
    height: 20px;
    background: #F04037;
    position: absolute;
    left: 0;
    top: 5px;
  }
}

.player-wrapper {
  margin: 26px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/DownloadAll.vue